import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import Link from '../../../shared/ui/Link'
import Button from '../../../shared/ui/Button'

import { withStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar'
import ProviderIcon from '@material-ui/icons/School'

const styles = theme => ({
  root: {
  },
  providerCard: {
    //padding: theme.spacing.unit * 2,    
  },
  providerNameContainer: {
    // height: '3rem',
    // overflow: 'hidden'
  },
  providerCardAvatar: {
    width: theme.spacing(8),
    height: theme.spacing(8),    
  },
  providerCardName: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
  providerHeadlineContainer: {
    height: '4.5rem',
    marginBottom: theme.spacing(.5),
    overflow: 'hidden'
  }
})

const ProviderCard = ({ theme, classes, item, linkTo, showVisitButton=true, target="_blank" }) => {

  let image_url = item.primary_image_url || ''
  
  return (
    <div className={classes.providerCard}>
      <Link to={linkTo} target={target}>
        <Box display='flex' alignItems='center'>
        {item.logo_url ?
        <Avatar src={item.logo_url} className={classes.providerCardAvatar} />
        :
        <Avatar className={classes.providerCardAvatar}>
          <ProviderIcon />
        </Avatar>
        }
        <Box flexGrow={1} ml={1}>
          <Box className={classes.providerNameContainer}>
            <Typography variant="body2" className={classes.providerCardName}>
              { item.name }
            </Typography>
          </Box>
          { item.headline &&
            <Box className={classes.providerHeadlineContainer}>
              <Typography variant="body2">
                { item.headline }
              </Typography>
            </Box>
          }
          { showVisitButton &&
            <Box mt={1}>
              <Button variant="contained" color='default'>Visit</Button>
            </Box>
          }
        </Box>
        </Box>
      </Link>        
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(
  ProviderCard
)
